import React from "react";
import CustomButton from "../components/common/CustomBtn";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <section>
      <div className="w-full mt-20 sm:mt-24 flex justify-center min-h-[79vh]  px-5 ">
        <div className="flex flex-col items-center justify-center gap-4 py-24 ">
          <h2 className="font-semibold text-md md:text-lg">404 Not Found 😔</h2>
          <p className="text-base font-medium text-center">
            Sorry, the page you're looking for does not exist.
          </p>
          <CustomButton onClick={() => navigate("/")}>
            Go Back Home
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
